"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _StartStreamButton = require("../StartStreamButton");
var _StreamPlayer = require("../StreamPlayer");
var _Link = require("../Link");
var _Timer = require("../Timer");
var _Preview = require("./Preview.styled");
var _interactiveStream = require("../../../constants/interactiveStream");
var _constants = require("../../../constants");
var _PlaybackWaiting = require("../PlaybackWaiting");
var _TheaterInfo = require("../TheaterInfo");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Preview = exports.Preview = function Preview(_ref) {
  var playbackUrl = _ref.playbackUrl,
    sourceType = _ref.sourceType,
    embedCode = _ref.embedCode,
    shortId = _ref.shortId,
    startedOn = _ref.startedOn,
    isLive = _ref.isLive,
    onLiveToggle = _ref.onLiveToggle,
    isPreviewing = _ref.isPreviewing,
    startOn = _ref.startOn,
    endOn = _ref.endOn,
    onTheaterInfoEdit = _ref.onTheaterInfoEdit,
    description = _ref.description,
    authentication = _ref.authentication,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme;
  var _useState = (0, _react.useState)(sourceType === _constants.EMBED_SOURCE_TYPE),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    canStartStream = _useState2[0],
    setCantartStream = _useState2[1];
  var playbackWaitingMessage = 'There is no Studio that is currently streaming into this theater.';
  var startStreamToolTipText = 'This will reveal the stream player for everyone in the theater. Only do this when ready to start the show.';
  var endStreamToolTipText = 'This will remove the stream player for everyone in the theater. Only do this when the show has ended.';
  var noStreamToolTipText = 'You must have an active player source to start the stream';
  var isPlaying = isLive || isPreviewing || sourceType === _constants.EMBED_SOURCE_TYPE;
  var toolTipText = noStreamToolTipText;
  if (canStartStream && isLive) {
    toolTipText = endStreamToolTipText;
  } else if (canStartStream) {
    toolTipText = startStreamToolTipText;
  }
  var setCantartStreamCb = function setCantartStreamCb() {
    setCantartStream(true);
  };
  (0, _react.useEffect)(function () {
    if (sourceType === _constants.EMBED_SOURCE_TYPE) {
      setCantartStream(true);
    } else {
      setCantartStream(false);
    }
  }, [sourceType]);
  var buttonDisabled = !canStartStream;
  if (sourceType === _constants.EMBED_SOURCE_TYPE && !embedCode) {
    buttonDisabled = true;
    toolTipText = noStreamToolTipText;
  }
  return /*#__PURE__*/_react["default"].createElement(_Preview.PreviewContainer, null, /*#__PURE__*/_react["default"].createElement(_Preview.PreviewWrapper, null, /*#__PURE__*/_react["default"].createElement(_Preview.PreviewHeader, null, /*#__PURE__*/_react["default"].createElement(_Preview.HeaderText, null, "Stream preview"), /*#__PURE__*/_react["default"].createElement(_Preview.PreviewHeaderButtonWrapper, null, isLive && /*#__PURE__*/_react["default"].createElement(_Timer.Timer, {
    startedOn: startedOn
  }), /*#__PURE__*/_react["default"].createElement(_StartStreamButton.StartStreamButton, {
    onClick: onLiveToggle,
    tooltipText: toolTipText,
    tooltipPlacement: "top",
    dataTestId: "start-stream-button",
    disabled: buttonDisabled,
    toolTipWidth: 500,
    isLive: isLive
  }))), /*#__PURE__*/_react["default"].createElement(_Preview.PreviewBody, {
    className: "preview-body"
  }, isPlaying ? /*#__PURE__*/_react["default"].createElement(_StreamPlayer.StreamPlayer, {
    playbackUrl: playbackUrl,
    sourceType: sourceType,
    embedCode: embedCode,
    playbackWaitingMessage: playbackWaitingMessage,
    onPlaybackStarted: setCantartStreamCb
  }) : /*#__PURE__*/_react["default"].createElement(_PlaybackWaiting.PlaybackWaiting, {
    message: playbackWaitingMessage
  })), /*#__PURE__*/_react["default"].createElement(_Preview.PreviewFooter, {
    className: "preview-footer"
  }, /*#__PURE__*/_react["default"].createElement(_TheaterInfo.TheaterInfo, {
    startOn: startOn,
    endOn: endOn,
    description: description,
    authentication: authentication,
    sourceType: sourceType,
    featuredImage: theme.featuredImageUrl,
    onTheaterInfoEdit: onTheaterInfoEdit
  }), /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    shortId: shortId,
    title: "Theater link",
    subTitle: "Direct link to this theater"
  }))));
};
Preview.propTypes = {
  playbackUrl: _propTypes.string,
  sourceType: _interactiveStream.SOURCE_TYPE_PROPS,
  embedCode: _propTypes.string,
  shortId: _propTypes.string,
  startedOn: _propTypes.number,
  isLive: _propTypes.bool,
  onLiveToggle: _propTypes.func.isRequired,
  isPreviewing: _propTypes.bool,
  onTheaterInfoEdit: _propTypes.func.isRequired
};